import { handleActions } from 'redux-actions';
import { NotificationManager } from "react-notifications";
import { initialize as initializeForm, reset } from 'redux-form';
import { api } from "api";
import { months } from '../../../../common/components/Utils/months';
import { getFloat } from '../../../../utility/format';
import { getResponseError } from '../../../../utility/getErrors';

let url = 'comparativo_flujo_caja';
let form = 'ComparativoFlujoCajaForm';

// ------------------------------------
// Constants
// ------------------------------------
export const constants = {
    LOADER: 'COMPARATIVO_FLUJO_CAJA_LOADER',
    DATA: 'COMPARATIVO_FLUJO_CAJA_DATA',
    ITEM_DATA: 'COMPARATIVO_FLUJO_CAJA_ITEM',
    SET_CURRENCY: 'SET_CURRENCY'
}


// -----------------------------------
// Pure Actions
// -----------------------------------
const setLoader = loader => ({
    type: constants.LOADER,
    loader,
});
const setData = data => ({
    type: constants.DATA,
    data,
});
const setItem = item => ({
    type: constants.ITEM_DATA,
    item,
});


// -----------------------------------
// Actions
// -----------------------------------
const read = () => async (dispatch, getState) => {
    // usar reset de redux
    dispatch(reset(form));

    dispatch(setLoader(true));
    // dispatch(setData({}));
    // dispatch(initializeForm(form, {}));
    dispatch(setCurrency('USD'));

    try {
        const comparativoTablesResponse = await api.get(`${url}/get_tables_comparativo_flujo_caja`);

        dispatch(setData(comparativoTablesResponse));
        dispatch(initializeForm(form, comparativoTablesResponse));
    } catch (error) {
        const elError = getResponseError(error, 'Error en la carga de datos');
        NotificationManager.error(elError, 'ERROR', 3000);
    } finally {
        dispatch(setLoader(false));
    }
};

const getDollar = () => (dispatch) => {
    // dispatch(setLoader(true));
    api.get(`administrative/get_dollar_exchange`).then((response) => {
        dispatch(setItem(response.dollar_exchange));
        dispatch(initializeForm(form, response.results));
    }).catch(() => {
    }).finally(() => {
        // dispatch(setLoader(false));
    });
};


const guardarCambios = (data) => (dispatch) => {
    dispatch(setLoader(true));
    api.post(`${url}/save_comparativo_flujo_caja`, data).then(() => {
        NotificationManager.success('Reporte guardado', 'Éxito', 3000);
        // dispatch(setCurrency('USD'));
    }).catch((error) => {
        const elError = getResponseError(error, 'Error al guardar reporte');
        NotificationManager.error(elError, 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
        dispatch(read());
    });
};

const eliminarRegistro = id => (dispatch) => {
    // Validar que se proporciona un ID válido
    if (!id || id === 'undefined') {
        NotificationManager.error('No se puede eliminar un registro sin ID válido', 'ERROR', 3000);
        return;
    }
    
    dispatch(setLoader(true));
    api.eliminar(`${url}/${id}`).then(() => {
        NotificationManager.success('Registro eliminado correctamente', 'Éxito', 3000);
    }).catch((error) => {
        const elError = getResponseError(error, 'Error al eliminar registro');
        NotificationManager.error(elError, 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
        dispatch(read());
    });
};

//  ----------------
//  Resumen
// -----------------
const setCurrency = (currency) => (dispatch) => {
    dispatch({ type: constants.SET_CURRENCY, currency })
}

const convertValues = (item, factor) => {
    months.forEach(month => {
        if (item.hasOwnProperty(month)) {
            item[month] = item[month] * factor;
        }
    });

    if (item.hasOwnProperty("total")) {
        item.total = item.total * factor;
    }

    return item;
};

const convertNestedData = (data, factor) => {
    if (Array.isArray(data)) {
        return data.map(item => {
            if (item.results && Array.isArray(item.results)) {
                return {
                    ...item,
                    results: convertNestedData(item.results, factor),
                };
            }

            return convertValues({ ...item }, factor);
        });
    }
    return data;
};

const convertCurrency = (data, exchangeRate, currency) => {
    const isToDollar = currency === 'USD';
    const factor = isToDollar ? (1 / exchangeRate) : exchangeRate;

    if (data.hasOwnProperty("investments")) {
        data.investments = convertNestedData(data.investments, factor);
    }

    if (data.hasOwnProperty("financial")) {
        data.financial = convertNestedData(data.financial, factor);
    }

    if (data.hasOwnProperty("operation")) {
        data.operation = convertNestedData(data.operation, factor);
    }

    if (data.hasOwnProperty("summary")) {
        data.summary = convertNestedData(data.summary, factor);
    }

    return data;
};

const changeCurrency = (currency, exchangeRate) => async (dispatch, getState) => {
    // dispatch(setLoader(true));

    try {
        const state = getState();
        const formState = state.form.ComparativoFlujoCajaForm;

        if (!formState || !formState.values) {
            console.error("No hay valores en el formulario");
            return;
        }

        const convertedData = convertCurrency(formState.values, exchangeRate, currency);
        dispatch(setData(convertedData));
        dispatch(initializeForm(form, convertedData));

    } catch (error) {
        console.error(error);
    }
    finally {
        // dispatch(setLoader(false));
    }


};

// ____________________ ACTUALIZACION DE RESUMEN ____________________
const updateResumen = (index, table, month) => (dispatch, getState) => {
    dispatch(setLoader(true));

    try {
        const state = getState();
        const formState = state.form.ComparativoFlujoCajaForm;

        if (!formState || !formState.values) {
            console.error("No hay valores en el formulario");
            return;
        }

        const allValues = formState.values;

        let newData = allValues;

        newData = updateMonthEntradasYSalidas(allValues, month);

        // dispatch(setData(newData));
        // dispatch(initializeForm(form, newData));

        updateTotales(allValues, month);
    } catch (error) {
        console.error(error);
    } finally {
        dispatch(setLoader(false));
    }
}

const updateMonthEntradasYSalidas = (allValues, month) => {
    const investments = allValues.investments || [];
    let operation = allValues.operation || [];
    const financial = allValues.financial || [];

    const summary = allValues.summary || [];

    // para no sumar los totales y el resto de celdas en flujos de operación
    if (operation.length >= 20) {
        // se utilizan solo los totales
        const totalesEntrada = operation[0];
        const totalesSalida = operation[9];
        const totalesOtros = operation[20];

        operation = [totalesEntrada, totalesSalida, totalesOtros];

        // alternativa contraria
        // quitar los totales (sería menos eficiente)
        // operation = operation.filter((_, index) => ![0, 9, 20].includes(index));
    }

    const todosLosRegistros = operation.concat(financial).concat(investments);

    let totalEntradas = 0;
    let totalSalidas = 0;

    for (let i = 0; i < todosLosRegistros.length; i++) {
        const valor = getFloat(todosLosRegistros[i][month]);
        if (valor < 0) {
            totalSalidas += valor;
        } else {
            totalEntradas += valor;
        }
    }

    const indexEntradas = 1;
    const indexSalidas = 2;

    // actualizar summary
    summary[indexEntradas][month] = totalEntradas;
    summary[indexSalidas][month] = totalSalidas;

    return { ...allValues, ...summary };
}

const updateTotales = (allValues, month) => {
    const summary = allValues.summary || [];

    const indexSaldoInicial = 0;
    const indexEntradas = 1;
    const indexSalidas = 2;
    const indexFlujoCajaNeto = 3;
    const indexSaldoFinalMes = 4;

    // actualizar flujo de caja neto
    // salidas ya vienen negativas
    summary[indexFlujoCajaNeto][month] = getFloat(summary[indexEntradas][month]) + getFloat(summary[indexSalidas][month]);
    // actualizar saldo final del mes
    summary[indexSaldoFinalMes][month] = getFloat(summary[indexSaldoInicial][month]) + getFloat(summary[indexFlujoCajaNeto][month]);

    // actualizar el saldo inicial de los siguientes meses
    for (let mesIndex = months.indexOf(month); mesIndex < months.length - 1; mesIndex++) {
        const mesSiguiente = months[mesIndex + 1];
        summary[indexSaldoInicial][mesSiguiente] = getFloat(summary[indexSaldoFinalMes][months[mesIndex]]);

        summary[indexFlujoCajaNeto][mesSiguiente] = getFloat(summary[indexEntradas][mesSiguiente]) + getFloat(summary[indexSalidas][mesSiguiente]);
        summary[indexSaldoFinalMes][mesSiguiente] = getFloat(summary[indexSaldoInicial][mesSiguiente]) + getFloat(summary[indexFlujoCajaNeto][mesSiguiente]);
    }

    return { ...allValues, ...summary };
}

export const actions = {
    guardarCambios,
    read,
    getDollar,
    eliminarRegistro,
    changeCurrency,
    setCurrency,
    updateResumen,
    setLoader,
};

// -----------------------------------
// Reducers
// -----------------------------------
const reducers = {
    [constants.LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [constants.DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [constants.ITEM_DATA]: (state, { item }) => {
        return {
            ...state,
            item,
        };
    },
    [constants.SET_CURRENCY]: (state, { currency }) => {
        return {
            ...state,
            currency: currency,
        };
    },

};
export const initialState = {
    loader: false,
    data: {},
    exchangeRate: 7.8,
    currency: 'USD',
    item: {},
};
export default handleActions(reducers, initialState)
